import React from 'react';
import logo from '../Assets/ISS.png'
import './style.css';
const Brand = ({url}) => (
  <div className="brand-logo">
    <img src={logo} alt=""/>
  </div>
);
export default Brand;